export class Company {
    id?: number;
    name: string;
    hubSpotCompanyId: string;
    partnerCompanyId: string;
    domain: string;
}